import { render, staticRenderFns } from "./ImportTripsToInvoice.vue?vue&type=template&id=06ac84c2&scoped=true&"
import script from "./ImportTripsToInvoice.vue?vue&type=script&lang=js&"
export * from "./ImportTripsToInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ImportTripsToInvoice.vue?vue&type=style&index=0&id=06ac84c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac84c2",
  null
  
)

export default component.exports